import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idSocio: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
  tipoCambio: Yup.number().min(1).required(),
  moneda: Yup.string().required(),
  serieDocumento: Yup.string().required(),
  numeroDocumento: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  // fechaAlmacenamiento: Yup.string().required(),
  fechaVencimiento: Yup.string().required()
})
